<ng-container [ngSwitch]="health">
  <mat-icon *ngSwitchCase="true" class="valid">
    check_circle
  </mat-icon>
  <mat-icon *ngSwitchCase="false" class="invalid" >
    cancel
  </mat-icon>
</ng-container>
